'use strict';
import React, {useEffect, useState} from "react";
import {StyleSheet, Animated} from "react-native";
import { componentStyles} from "../../theme/styles";

export default function FloatingLabel(props) {
    let {
        label,
        labelColor,
        isFocused,
        style,
        hasValue
    } = props;

    const [posTop, setPosTop] = useState(props.hasValue ? 20 : -8)
    const [font, setFont] = useState(props.hasValue ? 16 : 12)
    const [top, setTop] = useState(new Animated.Value(props.hasValue ? 20 : -8))
    const [fontSize, setFontSize] = useState(new Animated.Value(props.hasValue ? 16 : 12))
    useEffect(() => {
        if (!hasValue && !isFocused) {
            setPosTop(20);
            setFont(16)
            setFontSize(new Animated.Value(16))
            setTop(new Animated.Value(20))
            sinkLabel()
        } else {
            setPosTop(-8);
            setFont(12)
            setFontSize(new Animated.Value(12))
            setTop(new Animated.Value(-8))
            floatLabel()
        }
    }, [hasValue])
    useEffect(() => {
        if (isFocused) {
            setPosTop(-8);
            setFont(12)
            setFontSize(new Animated.Value(12))
            setTop(new Animated.Value(-8))
            floatLabel()
        } else {
            if (!hasValue) {
                setPosTop(20);
                setFont(16)
                setFontSize(new Animated.Value(16))
                setTop(new Animated.Value(20))
                sinkLabel()
            }
        }
    }, [isFocused])

    useEffect(() => {

        if (hasValue) {
            setPosTop(-5);
            setFont(12)
            setFontSize(new Animated.Value(12))
            setTop(new Animated.Value(-5))
            floatLabel()
        }
    }, [])

    const floatLabel = () => {
        Animated.parallel([
            Animated.timing(top, {
                useNativeDriver: false,
                toValue: posTop,
                duration: props.duration
            }),
            Animated.timing(fontSize, {
                useNativeDriver: false,
                toValue: font,
                duration: props.duration
            })
        ]).start();
    }
    const sinkLabel = () => {
        Animated.parallel([
            Animated.timing(top, {
                useNativeDriver: false,
                toValue: top,
                duration: props.duration
            }),
            Animated.timing(fontSize, {
                useNativeDriver: false,
                toValue: fontSize,
                duration: props.duration
            })
        ]).start();
    }
    return (
        <Animated.Text
            style={[componentStyles.text, {
                fontSize: fontSize,
                top: top,
                color: labelColor
            }, localstyles.labelText
                , top._value === -8 && {paddingRight: 0, marginRight: 0}, style, isFocused &&
                {color: labelColor ? labelColor : 'gray'}]}
            onPress={() => {
                props.focusHandler();
            }}
        >
            {label}
        </Animated.Text>
    );

}


const localstyles = StyleSheet.create({
    labelText: {
        position: 'absolute',
        right: 1,
        paddingLeft: 10,
        paddingRight: 5,
        marginRight: 5,
        backgroundColor: 'transparent',
    }
});
